<!DOCTYPE html>
@if (showPage()) {
  @if (!isDownload) {
    <div class="content-area">
      <div class="otsc-catalog-header">
        <div id="details-download-product-title" class="otsc-catalog-header-title is-pulled-left">
          {{getProductName(product, true)}}
        </div>
        <div class="otsc-catalog-download is-pulled-right">
          <button id="details-download-button" role="button" otsc-button color="primary" i18n-title title="Download" [routerLink]="['./download']" (click)="onDownload()">Download</button>
        </div>
      </div>
      @if (dependencyTabs.length > 0) {
        <div id="details-tab-section" class="ot-panel contant-area">
          <app-tabs [identifier]="'catalog-details-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="dependencyTabs" [color]="TabColor.SECONDARY" [selectedIndex]="activeTab"></app-tabs>
          @if (activeTab !== 0) {
            <div class="tab-content">
              <ng-scrollbar>
                <div class="wrapper">
                  <table [id]="identifier" tabindex="0">
                    <thead>
                      <tr>
                        <th class="fixed header-border-right-only component-col"></th>
                        @for (productColumn of columns; track productColumn) {
                          <th [attr.colspan]="productColumn.subColumns.length">
                            <div style="text-align: center;"><span [title]="productColumn.productName">{{productColumn.productName}}</span></div>
                          </th>
                        }
                      </tr>
                      <tr>
                        <th class="fixed header-border-top component-col" title="Components" i18-title i18n>Components</th>
                        @for (productColumn of columns; track productColumn) {
                          @for (sub of productColumn.subColumns; track sub) {
                            <th>
                              <div><span [title]="sub.shortName">{{sub.shortName}}</span></div>
                            </th>
                          }
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (component of dependencies[activeTabText] | keyvalue; track component) {
                        <tr>
                          <td class="fixed"><span class="product-text" [title]="component.key">{{component.key}}</span></td>
                          @for (productColumn of columns; track productColumn) {
                            @for (sub of productColumn.subColumns; track sub) {
                              <td>
                                @if (isDependencySupported(activeTabText, component.key, productColumn.productName, sub.shortName)) {
                                  <div class="dot-container">
                                    <span class="dot" title="Supported" i18-title></span>
                                  </div>
                                }
                              </td>
                            }
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </ng-scrollbar>
            </div>
          }
          @if (activeTab == 0) {
            <div id="details-overview-tab-content" class="ot-panel__body">
              <div class="ot-row">
                <div class="ot-row__column">
                  <small id="catalog-product-name-label" class="ot--has-text-muted">Name</small>
                  <p id="catalog-product-name">{{getProductName(product)}}</p>
                </div>
                <div class="ot-row__column">
                  <small id="catalog-product-version-label" class="ot--has-text-muted">Version</small>
                  <p id="catalog-product-version">{{product.version}}</p>
                </div>
              </div>
              @if (product.documentations.documentation != '') {
                <div>
                  <div class="ot-row" >
                    <div class="ot-row__column">
                      <small id="catalog-product-release-notes-label" class="ot--has-text-muted">Release notes</small>
                      <p class="ot-icon-url">
                        <a id="catalog-product-release-notes" [href]="product.documentations.releaseNotes" target="_blank" aria-label="Release notes">
                          <i class="ot-icon otsc-icon-url"></i>
                        </a>
                      </p>
                    </div>
                    <div class="ot-row__column">
                      <small id="catalog-product-documentation-label" class="ot--has-text-muted">Additional documentation</small>
                      <p class="ot-icon-url">
                        <a id="catalog-product-documentation" [href]="product.documentations.documentation" target="_blank" aria-label="Documentation">
                          <i class="ot-icon otsc-icon-url"></i>
                        </a>
                      </p>
                    </div>
                  </div>
                  <div class="ot-row">
                    <div class="ot-row__column">
                      <small id="catalog-product-release-date-label" class="ot--has-text-muted">Release date</small>
                      <p id="catalog-product-release-date">{{product.releaseTimestamp | fromNow}}</p>
                    </div>
                  </div>
                </div>
              } @else {
                <div class="ot-row" >
                  <div class="ot-row__column">
                    <small id="catalog-product-release-notes-label" class="ot--has-text-muted">Release notes</small>
                    <p class="ot-icon-url">
                      <a id="catalog-product-release-notes" [href]="product.documentations.releaseNotes" target="_blank" aria-label="Release notes">
                        <i class="ot-icon otsc-icon-url"></i>
                      </a>
                    </p>
                  </div>
                  <div class="ot-row__column">
                    <small id="catalog-product-release-date-label" class="ot--has-text-muted">Release date</small>
                    <p id="catalog-product-release-date">{{product.releaseTimestamp | fromNow}}</p>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  <router-outlet></router-outlet>
} @else {
  <div id="catalog-details-loading" class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter">
      </div>
    </div>
    <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
  </div>
}
